import classNames from 'classnames';

const Filtering = ({
    tab,
    updateTab,
}) => (
    <div className="tabsContainer">
        <div className="tabs">
            <div
                onClick={() => updateTab('allocatedAddresses')}
                className={classNames('tabs__item', { active: tab === 'allocatedAddresses' })}
            >
                Allocated Addresses
            </div>
            <div
                onClick={() => updateTab('history')}
                className={classNames('tabs__item', { active: tab === 'history' })}
            >
                History
            </div>
        </div>
    </div>
);

export default Filtering;
